import { render, staticRenderFns } from "./dj-form-footer.vue?vue&type=template&id=4a2f7bd7&scoped=true&"
import script from "./dj-form-footer.vue?vue&type=script&lang=js&"
export * from "./dj-form-footer.vue?vue&type=script&lang=js&"
import style0 from "./dj-form-footer.vue?vue&type=style&index=0&id=4a2f7bd7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2f7bd7",
  null
  
)

export default component.exports